module.exports = __webpack_public_path__ + "static/img/Popcorner-Standee.a53ed5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advertisingImagesNew/Popcorner-Standee.jpg
// module id = RfGf
// module chunks = 12